import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../config/branding';

const supportEmail = SUPPORT_EMAIL;

/**
 * Aide accès — pas d’API de réinitialisation automatique dans la plateforme pour l’instant :
 * orientation vers administrateur organisation ou support.
 */
const ForgotPassword = () => {
  const [params] = useSearchParams();
  const topic = params.get('topic') || 'password';

  const isUsername = topic === 'username';

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-lg px-4 py-12 sm:px-6 sm:py-16">
        <Link
          to="/"
          className="mb-8 inline-flex items-center gap-2 text-sm font-medium text-indigo-600 hover:text-indigo-800"
        >
          ← Accueil Entrea
        </Link>

        <div className="rounded-xl border border-slate-200/90 bg-[#f4f7f9] px-6 py-8 shadow-sm sm:px-8">
          <h1 className="text-2xl font-bold text-slate-900">
            {isUsername ? 'Identifiant oublié ou inaccessible' : 'Mot de passe oublié'}
          </h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            {isUsername ? (
              <>
                Votre <strong>nom d&apos;utilisateur</strong> est en général attribué par l&apos;administrateur de votre
                organisation. Si vous ne le retrouvez pas, contactez un responsable de votre association ou le support
                de la structure qui gère votre espace Entrea.
              </>
            ) : (
              <>
                Si c&apos;est votre <strong>première connexion</strong>, utilisez le mot de passe initial communiqué
                par votre organisation (souvent le même pour tous les nouveaux membres) — vous le changerez ensuite sur
                l&apos;écran dédié. Sinon, la <strong>réinitialisation</strong> est faite par un administrateur de
                votre organisation. Pas de réinitialisation automatique par e-mail sur cette interface pour l&apos;instant.
              </>
            )}
          </p>

          <ul className="mt-6 list-disc space-y-2 pl-5 text-slate-700 text-sm">
            <li>Vérifiez vos messages ou documents de bienvenue (identifiant communiqué à l&apos;inscription).</li>
            <li>Demandez à un administrateur Entrea de votre organisation de réinitialiser votre mot de passe.</li>
            {supportEmail ? (
              <li>
                Pour un problème plateforme :{' '}
                <a href={`mailto:${supportEmail}`} className="font-semibold text-indigo-600 underline">
                  {supportEmail}
                </a>
                .
              </li>
            ) : (
              <li>
                Pour un problème technique global, utilisez le canal support habituel de votre déploiement Uruganda
                Platform.
              </li>
            )}
          </ul>

          <div className="mt-8 flex flex-col gap-3 border-t border-slate-200/80 pt-6 sm:flex-row sm:flex-wrap">
            <Link
              to="/login"
              className="inline-flex justify-center rounded-lg bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700"
            >
              Retour à la connexion
            </Link>
            <Link
              to="/portal/login"
              className="inline-flex justify-center rounded-lg border border-indigo-200 bg-white px-5 py-2.5 text-sm font-semibold text-indigo-700 hover:bg-indigo-50"
            >
              Connexion administrateur (écran classique)
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
